var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHigh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#6F6F6F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7498 10.0571L9.53228 6.87712C9.46256 6.80683 9.37961 6.75103 9.28821 6.71295C9.19682 6.67488 9.09879 6.65527 8.99978 6.65527C8.90077 6.65527 8.80274 6.67488 8.71135 6.71295C8.61995 6.75103 8.537 6.80683 8.46728 6.87712L5.28728 10.0571C5.21698 10.1268 5.16119 10.2098 5.12311 10.3012C5.08503 10.3926 5.06543 10.4906 5.06543 10.5896C5.06543 10.6886 5.08503 10.7867 5.12311 10.8781C5.16119 10.9694 5.21698 11.0524 5.28728 11.1221C5.4278 11.2618 5.61789 11.3402 5.81603 11.3402C6.01417 11.3402 6.20426 11.2618 6.34478 11.1221L8.99978 8.46712L11.6548 11.1221C11.7945 11.2607 11.983 11.3388 12.1798 11.3396C12.2785 11.3402 12.3763 11.3213 12.4677 11.284C12.5591 11.2466 12.6422 11.1916 12.7123 11.1221C12.7851 11.0549 12.8439 10.9739 12.8852 10.8839C12.9265 10.7938 12.9496 10.6965 12.9531 10.5974C12.9566 10.4984 12.9404 10.3997 12.9055 10.3069C12.8706 10.2142 12.8177 10.1293 12.7498 10.0571Z",
    fill: "#EDF0EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigh);
export default __webpack_public_path__ + "static/media/high.b0f9a3ec9dedef238cd5d02705758734.svg";
export { ForwardRef as ReactComponent };